// Generated by ReScript, PLEASE EDIT WITH CARE

import JwtDecode from "jwt-decode";

function decode(string) {
  let response;
  try {
    response = JwtDecode(string);
  } catch (exn) {
    return;
  }
  return response;
}

export {
  decode,
}
/* jwt-decode Not a pure module */
